import { render, staticRenderFns } from "./ReadingSpeed.vue?vue&type=template&id=05f41fdf&"
import script from "./ReadingSpeed.vue?vue&type=script&lang=js&"
export * from "./ReadingSpeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports